import {
	CORE_PACKAGES_PREDEFINED_DISCOUNT_KEYS,
	CORE_SERVICES_EXPIRATION_TYPES,
} from 'Constants';
import { TakhfDate } from 'Helpers';

export const getFormInfoFromPackageData = (packageData) => {
	let formInfo = {
		packageName: packageData.attributes?.name,
		category: packageData.attributes?.service?.id,
		price: packageData.attributes?.price,
		discountDropdown: null,
		discountCustomPercent: '',
		usage_conditions: packageData.attributes?.usage_conditions,
		images: packageData.attributes?.images || [],
		description: packageData.attributes?.description,
		dynamic_attributes: packageData.attributes?.dynamic_attributes,
		quantity: packageData.attributes?.maximum_sellable_quantity,
		sort_order: packageData.attributes?.sort_order,
	};

	return {
		...formInfo,
		...onCalculatePackagePercentInfo(
			packageData.attributes?.price,
			packageData.attributes?.discount_price
		),
		...onCalculatePackageDateInfo(packageData.attributes),
	};
};

const onCalculatePackagePercentInfo = (price = 1, discount_price = 1) => {
	let percentNumber = Math.round((1 - discount_price / price) * 100);
	if (
		Object.values(CORE_PACKAGES_PREDEFINED_DISCOUNT_KEYS).includes(
			percentNumber
		)
	) {
		return { discountDropdown: percentNumber };
	}
	return {
		discountDropdown: CORE_PACKAGES_PREDEFINED_DISCOUNT_KEYS.CUSTOM,
		discountCustomPercent: percentNumber,
	};
};

const onCalculatePackageDateInfo = (packageData) => {
	if (packageData?.coupon_start_date && packageData?.coupon_end_date) {
		return {
			expirationType: CORE_SERVICES_EXPIRATION_TYPES.TIME_ZONE,
			coupon_start_date: TakhfDate.formatDate(
				packageData.coupon_start_date,
				TakhfDate.MOMENT_DATE_FORMATS.YMD_DASH
			),
			coupon_end_date: TakhfDate.formatDate(
				packageData.coupon_end_date,
				TakhfDate.MOMENT_DATE_FORMATS.YMD_DASH
			),
		};
	}

	return {
		expirationType: CORE_SERVICES_EXPIRATION_TYPES.TIME_DUTATION,
		valid_to: packageData?.valid_to,
	};
};
